import {useEffect} from 'react';
import { BiDotsVerticalRounded } from "react-icons/bi";
import { IoIosCall, IoIosMailUnread } from "react-icons/io";
import { FiChevronRight } from "react-icons/fi";
import { FaPlayCircle } from "react-icons/fa";
import { IoTrashOutline } from "react-icons/io5";
// import { CSSTransition } from 'react-transition-group';
import { Popover, OverlayTrigger } from "react-bootstrap";
import { useContext } from 'react';
import VideoContext from '../../store/video-context';
import { toast } from 'react-toastify';
import { Question, Chat, Reply } from '../CustomIcons/CustomIcons';


const ChatBox = (props:any) => {
  const vContext = useContext(VideoContext);
  let item = props.chatsData;
  let replyItem = props.replyItem;
  let isChatPrivate = props.privateChat;

  useEffect(() => {
    // ($('.user-img')as any).popover({
    //   container: 'body'
    // });
    // console.log(props.replyItem);
  }, []);

  const dateMDT=(time:any)=>{
    let chatTime = new Date(time);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${monthNames[chatTime.getMonth()]}, ${chatTime.getDate()} ${chatTime.getHours()}:${chatTime.getMinutes()}`;
    // return chatTime1;
  }

  const handlerReplyChatMsg=(item:any)=>{
    // console.log("reply called");
    vContext.setIsReplyHandler(true);
    vContext.setReplyMsgHandler(item);
  }

  const scrollToReplyMsg = (item:any)=>{
    // document!.getElementById("chat_"+item.id).scrollIntoView();
    let chatElement = document.getElementById("chat_"+item.id);
    chatElement?.scrollIntoView();
  }

  const handlerMarkUnmarkChatAsQuestion=(item:any)=>{
    let markFlag = item.flag === "1"? 0: 1;
    fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=changeChatFlag&chatID="+item.id+"&flag="+markFlag)
    .then(res=>res.json())
    .then((markResponse)=>{
      if(markResponse.status === "success"){
        props.loadchat();
        let data = {
          id: item.id,
          name: item.chat_text,
          desc: "",
          time: Math.round(item.media_position),
          user_id: item.user_id,
          user_photo: item.user_photo,
          flag: "chat"
      }
        // console.log('after tagging', data);
      markFlag === 0 ? vContext.deleteAccordionDataHandler(item.id) : vContext.pushAccordionDataHandler(data);
        let msg = markFlag === 0 ? "Unmarked" : "Marked"
        toast.dark(msg +" Successfully!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
          // console.log("markResponse", markResponse );        
      }else{
        // console.log("Fail delete chat msg")
        toast.dark("Mark/Unmark Failed!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      }
    })
    .catch((error)=>{
      console.error('Error:(handlerDeleteChatMsg)', error);
    })
    document.body.click();
  }

  const handlerDeleteChatMsg=(msgId:any)=>{
    let data = { command:'deleteChat',transID: vContext.transId ,chatID:[msgId] };
    // fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=deleteChat&chatID="+msgId+"&transID="+vContext.transId)
    fetch('https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data) //JSON.stringify({a: 1, b: 'Textual content'})
  })
    .then(res=>res.json())
    .then((deleteChatMsgData)=>{
      // console.log('deleteChatMsgData',deleteChatMsgData);
      if(deleteChatMsgData.status === "success"){
        props.loadchat();
        vContext.deleteAccordionDataHandler(msgId)
        toast.dark("Chat Deleted Successfully!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      }else{
        // console.log("Fail delete chat msg")
        toast.dark("Delete Failed!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      }
    })
    .catch((error)=>{
      console.error('Error:(handlerDeleteChatMsg)', error);
    })
  }
  const convertSecondToHH_MM_SS = (seconds: any) => {
    return new Date(seconds * 1000).toISOString().substr(11, 8)
  }

  const popover = (
    <Popover id="popover-basic" className="chat-lg-tooltip">      
      <div className="chat-username-details lg-tooltip-container">
        <table>
          <tbody>
            <tr>
              <td>
                {
                  item.user_photo !== ''? 
                  <img src={window.location.origin + "/style/images/commonspeciality/dr_photos/" + item.user_photo} alt={item.user_name} className="user-img" />
                  : 
                  <div className="chat-initial d-flex justify-content-center align-items-center">
                    {/* {item.user_name.split(' ').map((name:any) => name[0]).join('').toUpperCase()} */}
                    {item.profile_name}
                  </div>
                }
              </td>
              <td>{item.user_name}</td>
            </tr>
            <tr>
              <td align="center" style={{padding: '5px'}}><IoIosCall size={16}/></td>
              <td style={{padding: '5px'}}>{item.mobile}</td>
            </tr>
            <tr>
              <td align="center"><IoIosMailUnread size={16}/></td>
              <td>{item.email}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Popover>
  );

  const popoverOptions = (
    <Popover id="popoverOptions" className="chat-lg-tooltip">
      <div className="chat-options-popup lg-tooltip-container">
        <table>
          <tbody>
            {/* <tr>
              <td align="center"><div className="d-flex align-items-center justify-content-center"><Chat className="mr-2" size={20} /> Chat</div></td>
            </tr>*/}
            <tr>
              <td align="center" style={{padding: '5px'}}><div className="d-flex align-items-center justify-content-center" onClick={()=>{handlerReplyChatMsg(item)}}><Reply className="mr-2" size={20} /> Reply</div></td>
            </tr> 
            <tr>
              <td align="center" style={{paddingBottom: '5px'}}><div className="d-flex align-items-center justify-content-center" onClick={()=>{handlerMarkUnmarkChatAsQuestion(item)}}><Question className="mr-2" size={20} /> {item.flag === '1'? "Unmark": "Mark"}</div></td>
            </tr>
            <tr>
              <td align="center" className="delete-btn"><div className="d-flex align-items-center justify-content-center" onClick={()=>{handlerDeleteChatMsg(item.id)}}><IoTrashOutline className="mr-2" size={20} /> Delete</div></td>
            </tr>
          </tbody>
        </table>
      </div>
    </Popover>
  );
  
  return(
      <div id={"chat_"+item.id} className={'chat-container ' + ((!isChatPrivate)? 'private-chat-container':'public-chat-container') + ((vContext.userData.user_id === item.user_id)? ' my-chat':'') + ((item.user_id == 1)? ' admin-chat':'')}>
          {(isChatPrivate)?
          <div className="d-flex align-items-end minw-100">
            { vContext.isAdmin ?
            <OverlayTrigger trigger={["hover","focus"]} placement="top" overlay={popover}>
              
                {
                  item.user_photo !== ''? 
                  <div className="chat-img lg-tooltip-trigger">
                    <img src={window.location.origin + "/style/images/commonspeciality/dr_photos/" + item.user_photo} alt={item.user_name} className="user-img" />
                  </div> 
                  : 
                  <div className="chat-img lg-tooltip-trigger chat-initial d-flex justify-content-center align-items-center">
                    {/* {item.user_name.split(' ').map((name:any) => name[0]).join('').toUpperCase()} */}
                    {item.profile_name}
                  </div>
                }              
            </OverlayTrigger>
            :
              <>
              {
                item.user_photo !== ''? 
                <div className="chat-img lg-tooltip-trigger">
                  <img src={window.location.origin + "/style/images/commonspeciality/dr_photos/" + item.user_photo} alt={item.user_name} className="user-img" />
                </div> 
                : 
                <div className="chat-img lg-tooltip-trigger chat-initial d-flex justify-content-center align-items-center">
                  {/* {item.user_name.split(' ').map((name:any) => name[0]).join('').toUpperCase()} */}
                  {item.profile_name}
                </div>
              }
            </>
            }
            <div className="chat-text">
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="chat-username pr-2">{item.user_name}</div>
                  <div className="chat-time">{dateMDT(item.chat_time)}</div>
                </div>
                { vContext.isAdmin &&
                  <OverlayTrigger trigger={['click']} placement="top" overlay={popoverOptions} rootClose={true}>
                    <div className="chat-options lg-tooltip-trigger">
                      <BiDotsVerticalRounded />                  
                    </div>
                  </OverlayTrigger>
                }
              </div>
              {replyItem &&
                <div className="chat-reply" onClick={()=>scrollToReplyMsg(replyItem)}>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="chat-reply-username pr-2">{replyItem.user_name}</div>
                      <div className="chat-reply-time">{dateMDT(replyItem.chat_time)}</div>
                    </div>
                  </div>
                  <div className="chat-reply-msg">{replyItem.chat_text}</div>
                </div>
              }
            
              <div className="chat-msg" dangerouslySetInnerHTML={{ __html: item.chat_text }}></div>
            <div className="d-flex justify-content-end my-2">
              <div className="chat-play-time" onClick={()=> props.seekVideo(item.media_position)}><FaPlayCircle className="mr-1" />{convertSecondToHH_MM_SS(item.media_position)}</div>
            </div>
            </div>
            <OverlayTrigger trigger={["hover","focus"]} placement="top" overlay={popover}>              
              {
                  item.user_photo !== ''? 
                  <div className="admin-chat-img">
                    <img src={window.location.origin + "/style/images/commonspeciality/dr_photos/" + item.user_photo} alt={item.user_name} className="user-img" />
                  </div> 
                  : 
                  <div className="admin-chat-img chat-initial d-flex justify-content-center align-items-center">
                    {/* {item.user_name.split(' ').map((name:any) => name[0]).join('').toUpperCase()} */}
                    {item.profile_name}
                  </div>
                }       
            </OverlayTrigger>
          </div>:
          <div className="w-100 minw-100">
            <div className="d-flex align-items-center">
              <div><input type="checkbox" checked={item.isSelected} onChange={()=>{props.chatSelected(item)}}/></div>              
              <>
              {
                item.user_photo !== ''? 
                <div className="chat-img lg-tooltip-trigger">
                  <img src={window.location.origin + "/style/images/commonspeciality/dr_photos/" + item.user_photo} alt={item.user_name} className="user-img" />
                </div> 
                : 
                <div className="chat-img lg-tooltip-trigger chat-initial d-flex justify-content-center align-items-center">
                  {/* {item.user_name.split(' ').map((name:any) => name[0]).join('').toUpperCase()} */}
                  {item.profile_name}
                </div>
              }
            </>
              <div className="chat-text">
                <div className="chat-username">{item.user_name}</div>
                <div className="chat-text" dangerouslySetInnerHTML={{ __html: item.chat_text }}></div>
              </div>
              <div className="chat-options">
                <FiChevronRight size={20} />
              </div>
            </div>
            <div className="d-flex justify-content-end my-2">
              <div className="chat-play-time" onClick={()=> props.seekVideo(item.media_position)}><FaPlayCircle className="mr-1" />
              {/* 00:31:28 */}
              {convertSecondToHH_MM_SS(item.media_position)}</div>
            </div>
          </div>
          } 
      </div>
  )
};

export default ChatBox;
